/** @format */

import Page from "../../components/Page";
import {
  Card,
  CircularProgress,
  Container,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import UserForm from "./UserForm";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import User from "../../dao/User";
import swal from "../../reusables/CustomSwal";
import * as Yup from "yup";
import { useFormik } from "formik";

export default function UserEdit() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState({});
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [wabas, setWabas] = useState([]);

  const getUserDetails = async () => {
    try {
      let result = await User.getByID(userId);

      setWabas(
        result.wabas.map((obj) => {
          return {
            waba_id: obj.waba_id,
            name: obj.name,
            label: `${obj.name} (${obj.waba_id})`,
          };
        })
      );

      setUserDetails({ ...result.profile, role: result.role });
      setIsDataLoading(false);
    } catch (e) {
      let errorMessage = "An error has occurred. Please try again.";
      let confirmResult = await swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "Go back",
      });
      if (confirmResult.isConfirmed || confirmResult.isDismissed) navigate(-1);
    }
  };

  const editUser = async (values) => {
    let body = values;

    let wabaObject = wabas.map((o) => o.waba_id);

    if (values.role === "MEMBER" || values.role === "ADMIN") {
      // if (wabaObject.length === 0)
      // return swal.fire({
      //   title: "Error",
      //   text: "Please assign a WABA ID to continue.",
      //   icon: "error",
      // });
      body = {
        ...values,
        wabas: wabaObject,
      };
    }

    delete body.email;
    delete body.role;

    let popupResult = await swal.fire({
      title: "Confirm",
      text: "Are you sure to save this user?",
      icon: "question",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
    });

    if (popupResult.isConfirmed) {
      try {
        // let queryResult = await User.update(userDetails.user_id, body);
        await User.update(userDetails.user_id, body);
        // console.log(queryResult);
        await swal.fire({
          title: "Success",
          text: "User data is saved.",
          icon: "success",
          confirmButtonText: "Go back",
        });
        navigate(-1);
      } catch (e) {
        console.log(e);
        let errorMessage = "An error has occurred. Please try again later.";
        if (e.code === "DUPLICATE_EMAIL")
          errorMessage = "Email has already been used.";
        else if (e.code === "INVALID_EMAIL" || e.code === "MISSING_INFO")
          errorMessage = "Please re-check the user data.";
        await swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
        });
      }
    }
  };

  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    first_name: userDetails.first_name,
    last_name: userDetails.last_name,
    job_title: userDetails.job_title,
    email: userDetails.email,
    phone_number: userDetails.phone_number,
    tenant: userDetails?.tenant,
    role: userDetails.role,
  };

  const EditSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required."),
    last_name: Yup.string(),
    job_title: Yup.string().required("Job Title is required."),
    email: Yup.string()
      .email("Email must be a valid email address.")
      .required("Email is required."),
    phone_number: Yup.string().required("Phone number is required."),
    tenant: Yup.string().nullable(),
    role: Yup.string().required("Please select a role."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: EditSchema,
    onSubmit: editUser,
  });

  return (
    <Page title="Edit User">
      <Container>
        <Stack spacing={2} direction="row" sx={{ mb: 4 }}>
          <IconButton
            sx={{ p: 0, height: "100%", backgroundColor: "white" }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={22} height={22} />
          </IconButton>
          <Typography variant="h4">Edit User</Typography>
        </Stack>
        <Card sx={{ p: 4 }}>
          {isDataLoading ? (
            <Stack alignItems="center">
              <CircularProgress />
            </Stack>
          ) : (
            <UserForm
              formik={formik}
              mode="edit"
              wabas={wabas}
              setWabas={setWabas}
            />
          )}
        </Card>
      </Container>
    </Page>
  );
}
